import React from "react";
import { Button, Modal, Form, Input, Radio, Select } from "antd";
const FormItem = Form.Item;
const Option = Select.Option;

const CHOICE_VALUE = {
	MISTYPED: "mistyped",
	RESIGNATION: "resignation",
	RETIREMENT: "retirement",
	OTHER: "other",
};

const CollectionCreateForm = Form.create()(
	(props) => {
		const { visible, onCancel, onCreate, form, user, confirmLoading } = props;
		const { getFieldDecorator, getFieldValue } = form;
		const titleMsg = `You want to delete ${Array.isArray(user) ? `${user.length} items` : user.user.email}?`;
		return (
			<Modal
				visible={visible}
				title={titleMsg}
				okText="Delete"
				onCancel={onCancel}
				onOk={onCreate}
				okType='danger'
				closable={false}
				maskClosable={false}
				confirmLoading={confirmLoading}
			>
				<Form layout="vertical">
					<FormItem label='Are you sure you want to delete?'
						onValuesChange={(props, values) => { console.log(props, values); }}>
						{getFieldDecorator("choice", {
							rules: [{ required: true, message: "Please select reason!" }],
						})
						(
							<Select placeholder="Please select a choice">
								<Option value={CHOICE_VALUE.MISTYPED}>Mistyped</Option>
								<Option value={CHOICE_VALUE.RESIGNATION}>Resignation</Option>
								<Option value={CHOICE_VALUE.RETIREMENT}>Retirement</Option>
								<Option value={CHOICE_VALUE.OTHER}>Other</Option>
							</Select>
						)
						}
						{getFieldValue("choice") === "other" ?
							<FormItem>
								{getFieldDecorator("reason", {
									rules: [{ required: true, message: "Please enter reason!" }],
								})(
									<Input.TextArea
										placeholder="Please enter reason"
										style={{ height: 150, marginTop: 10 }} row={12} />
								)}
							</FormItem> : null}
					</FormItem>
				</Form>
				{/* <span style={{ color: '#f5222d' }}>If you delete, you will not be able to roll back</span> */}
			</Modal>
		);
	}
);

class CollectionsPage extends React.Component {
    state = {
    	visible: false,
    	user: null,
    	confirmLoading: false,
    };
    showModal = (user) => {
    	if (user) {
    		this.setState({ visible: true, user });
    	}
    }
    handleCancel = () => {
    	if (!this.state.confirmLoading)
    		this.clearForm();
    }
    handleCreate = () => {
    	const form = this.form;
    	form.validateFields((err, values) => {
    		if (err) {
    			return;
    		}
    		const { user } = this.state;
    		let payload;
    		this.setState({ confirmLoading: true });
    		if (Array.isArray(user)) {
    			const employee_ids = user.map(value => value.id);
    			payload = this.packPayload(values, { employee_ids });
    			// onSubmitDeleteMultiple({ arraySelected, reason: values.reason }).then(() => this.clearForm())
    		} else {
    			payload = this.packPayload(values, { id: user.user.id });
    			// onSubmitDeleteEmployee({ id: user.user.id, reason: values.reason }).then(() => this.clearForm())
    		}
    		const { onSubmitDeleteEmployee, onDisableEmployee } = this.props;
    		if (values.choice === CHOICE_VALUE.MISTYPED) {
    			onSubmitDeleteEmployee(payload).then(() => this.clearForm());
    		} else {
    			onDisableEmployee(payload).then(() => this.clearForm());
    		}

    		// console.log(payload)


    		// 
    		// const { onSubmitDeleteEmployee } = this.props
    		// 

    	});
    }

    packPayload = (values, payload) => {
    	if (values.choice === CHOICE_VALUE.OTHER) payload.reason = values.reason;
    	else payload.reason = values.choice;
    	return payload;
    }

    clearForm() {
    	const form = this.form;
    	form.resetFields();
    	this.setState({ visible: false, user: null, confirmLoading: false });
    }

    saveFormRef = (form) => {
    	this.form = form;
    }
    render() {
    	return (
    		<div>
    			{
    				this.state.user &&
                    <CollectionCreateForm
                    	ref={this.saveFormRef}
                    	visible={this.state.visible}
                    	onCancel={this.handleCancel}
                    	onCreate={this.handleCreate}
                    	user={this.state.user}
                    	confirmLoading={this.state.confirmLoading}
                    />
    			}
    		</div>
    	);
    }
}

export default CollectionsPage;


// WEBPACK FOOTER //
// ./src/components/modal/DeleteEmployees.js